// 玩法 Demo 手機框＋畫面元件（照 couponly StoryPhone 樣式自寫 X-1493 版）
import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { QRCodeSVG } from 'qrcode.react';

/** me=true＝右側綠泡（客人發出） */
export function Chat({ me, text, buttons }: { me?: boolean; text: string; buttons?: string[] }) {
  return (
    <div className={`flex flex-col ${me ? 'items-end' : 'items-start'}`}>
      <div className={`max-w-[88%] rounded-2xl px-3 py-2.5 text-[10px] leading-relaxed ${me ? 'rounded-tr-sm bg-[#005c4b] text-white' : 'rounded-tl-sm bg-[#202c33] text-gray-200'}`}>
        {text}
      </div>
      {buttons && (
        <div className={`mt-1 flex w-[88%] flex-col ${me ? 'items-end' : 'items-start'}`}>
          {buttons.map((b) => (
            <div key={b} className="w-full rounded-lg bg-[#1f2c34] px-3 py-2 text-center text-[10px] font-bold text-[#53bdeb]">
              ↗ {b}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export function QrImg({ value, size = 128 }: { value: string; size?: number }) {
  return <QRCodeSVG value={value} size={size} level="M" />;
}

export function PhoneFrame({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="mx-auto w-[290px] shrink-0 sm:w-[300px]">
      <div className="rounded-[2rem] border-[9px] border-stone-800 bg-stone-800 shadow-2xl">
        <div className="relative h-[420px] overflow-hidden rounded-[1.3rem] bg-white">
          <div className="absolute left-1/2 top-0 z-20 h-5 w-24 -translate-x-1/2 rounded-b-2xl bg-stone-800" />
          {children}
        </div>
      </div>
      <div className="mt-2 text-center text-xs text-stone-400">{label}</div>
    </div>
  );
}

export function StoryStyles() {
  return (
    <style>{`
      @keyframes gfDemoStepIn { from { opacity: 0; transform: translateX(-10px); } to { opacity: 1; transform: none; } }
      @keyframes gfDemoPop { from { opacity: 0; transform: translateY(6px) scale(.97); } to { opacity: 1; transform: none; } }
      @keyframes gfDemoPulse { 0%,100% { box-shadow: 0 0 0 0 rgba(217,56,30,0); } 50% { box-shadow: 0 0 0 6px rgba(217,56,30,.15); } }
      @keyframes gfCaretBlink { 0%,45% { opacity: 1; } 50%,100% { opacity: 0; } }
      @keyframes gfCardSpot {
        0%, 33.3%, 100% { transform: scale(1); box-shadow: 0 1px 2px rgb(0 0 0 / .06); }
        5%, 28% { transform: scale(1.07); box-shadow: 0 12px 32px -8px rgb(217 56 30 / .45); }
      }
      .gf-step { opacity: 0; animation: gfDemoStepIn .45s ease forwards; }
      .demo-pop { opacity: 0; animation: gfDemoPop .4s ease forwards; }
      .demo-dot { animation: gfDemoPulse 2s ease infinite; }
      .type-caret { animation: gfCaretBlink 1s step-end infinite; color: #d9381e; }
      .spot-card { animation: gfCardSpot 6s ease-in-out infinite; }
    `}</style>
  );
}

/** 背景音樂——用戶點擊開關後啟動（瀏覽器自動播放限制）；循環＋音量 30% */
export function BgmToggle() {
  const [on, setOn] = useState(false);
  const [audio] = useState(() => {
    const el = new Audio('https://cdn.pixabay.com/audio/2024/11/01/audio_07b8f41a4c.mp3');
    el.loop = true;
    el.volume = 0.3;
    return el;
  });

  useEffect(() => {
    if (on) audio.play().catch(() => setOn(false));
    else audio.pause();
    return () => { audio.pause(); };
  }, [on, audio]);

  return (
    <button
      onClick={() => setOn((v) => !v)}
      aria-label={on ? '關閉背景音樂' : '開啟背景音樂'}
      className={`fixed bottom-4 right-4 z-40 flex h-11 w-11 items-center justify-center rounded-full text-lg shadow-lg transition ${
        on ? 'bg-red-600 text-white' : 'bg-white text-stone-500 ring-1 ring-stone-200 dark:bg-gray-800 dark:text-gray-300 dark:ring-gray-600'
      } ${on ? '' : ''}`}
    >
      {on ? '🔊' : '🔇'}
    </button>
  );
}
